import React from "react";
import { TableRow, TableSortLabel, TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";
import { RoleData } from "types/models/master/MasterApp";

interface TableHeadingProps {
  orderBy: string;
  order: "asc" | "desc";
  onSort: (property: keyof RoleData) => void;
}

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  padding: 8,
}));

const TableHeading: React.FC<TableHeadingProps> = ({ orderBy, order, onSort }) => {
  const createSortHandler = (property: keyof RoleData) => () => {
    onSort(property);
  };

  return (
    <TableRow>
      <StyledTableCell align="left">Action</StyledTableCell>

      <StyledTableCell
        align="left"
        sortDirection={orderBy === "Role" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "role"}
          direction={order}
          onClick={createSortHandler("role")}
        >
          Role Name
        </TableSortLabel>
      </StyledTableCell>

      <StyledTableCell
        align="left"
        sortDirection={orderBy === "moduleType" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "moduleType"}
          direction={order}
          onClick={createSortHandler("moduleType")}
        >
          Module Type
        </TableSortLabel>
      </StyledTableCell>

      <StyledTableCell
        align="left"
        sortDirection={orderBy === "isActive" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "isActive"}
          direction={order}
          onClick={createSortHandler("isActive")}
        >
          Status
        </TableSortLabel>
      </StyledTableCell>
    </TableRow>
  );
};

export default TableHeading;
